import React from 'react';
import { useDispatch } from 'react-redux';
import { useCartData } from '../../hooks/order';
import { saveSpanishLanguagePreference } from '../../store/action/OrderAction';
import { setManualLangPreference } from '../../util/languageDetect';

const LanguageToggle = () => {
  const dispatch = useDispatch();
  const { spanishLanguagePref } = useCartData();

  const handleToggle = () => {
    setManualLangPreference(!spanishLanguagePref)
    dispatch(saveSpanishLanguagePreference(!spanishLanguagePref));
  };

  return (
    <div className="lang-toggle-wrapper">
      <button
        type="button"
        onClick={handleToggle}
        className={`lang-toggle-pill ${spanishLanguagePref ? 'is-spanish' : ''}`}
        aria-label={spanishLanguagePref ? 'Switch to English' : 'Switch to Spanish'}
      >
        <span className="lang-toggle-thumb" />
        <span className="lang-toggle-label">{spanishLanguagePref ? 'ES' : 'EN'}</span>
      </button>
    </div>
  );
};

export default LanguageToggle;
